/*
This file contains these scripts:
 - Request
 - Section Renderer
 - CSS Variable
*/

var WDN = WDN || {};

if (typeof WDN.Request === "undefined") {
  WDN.Request = (function () {
    // Private function
    var _do;

    // Public function
    var Get, Post;

    var config = {
      defaultContentType: "application/json;charset=UTF-8",
      version: "1.1.2",
    };

    _do = function (obj) {
      var req = new XMLHttpRequest();

      if (obj.method == "POST" || obj.method == "PUT") {
        var contentType = obj.contentType || config.defaultContentType;
        req.open(obj.method, obj.url);
        req.setRequestHeader("Content-Type", contentType);
      }

      req.onreadystatechange = function () {
        if (req.readyState == 4) {
          if (req.status > 399 && req.status < 600) {
            if (obj.onError) {
              obj.onError(req.responseText);
            }
          }
          if (req.status == 200) {
            if (obj.onSuccess) {
              obj.onSuccess(req.responseText);
            }
          }
        }
      };

      if (obj.method == "POST" || obj.method == "PUT") {
        if (obj.contentType && obj.contentType !== config.defaultContentType) {
          req.send(obj.data);
        } else {
          req.send(JSON.stringify(obj.data));
        }
      } else {
        req.open("GET", obj.url, true);
        req.send(null);
      }
    };

    Get = function (obj) {
      _do({
        method: "GET",
        url: obj.url,
        onSuccess: function (res) {
          obj.type == "JSON" ? obj.onSuccess(JSON.parse(res)) : obj.onSuccess(res);
        },
        onError: function (res) {
          if (obj.onError) {
            if (obj.type == "JSON") {
              obj.onError(JSON.parse(res));
            } else {
              obj.onError(res);
            }
          }
        },
      });
    };

    Post = function (obj) {
      _do({
        method: "POST",
        url: obj.url,
        data: obj.data,
        contentType: obj.contentType,
        onSuccess: function (res) {
          obj.onSuccess(JSON.parse(res));
        },
        onError: function (res) {
          if (obj.onError) {
            obj.onError(res);
          }
        },
      });
    };

    return {
      Get: Get,
      Post: Post,
      Version: config.version,
    };
  })();
}

if (typeof WDN.SectionRenderer === "undefined") {
  WDN.SectionRenderer = (function () {
    var SectionRenderer;

    // Depends on
    var Routes = Shopify.routes;

    SectionRenderer = function (config) {
      this.config = config;
      this.storeNodes();
      this.complete = false;
      if (this.config.autoInit) {
        this.fetchSection();
        return;
      }
      this.init();
    };

    SectionRenderer.prototype.storeNodes = function () {
      this.outputs = document.querySelectorAll(this.config.selectors.output);
      if (this.config.triggers) {
        this.triggers = this.config.triggers;
        return;
      }
      this.triggers = document.querySelectorAll(this.config.selectors.trigger);
    };

    SectionRenderer.prototype.renderSections = function (response) {
      if (!response) return;
      var JSONResponse = JSON.parse(response);
      this.content = JSONResponse;
      var content = [];

      for (var section in JSONResponse) {
        if (JSONResponse.hasOwnProperty(section)) {
          content.push(JSONResponse[section]);
        }
      }

      if (this.config.replaceOutput) {
        this.outputs.forEach(function (output) {
          output.innerHTML = content.join("");
        });

        return;
      }

      this.outputs.forEach(function (output) {
        output.insertAdjacentHTML("beforeend", content.join(""));
      });
    };

    SectionRenderer.prototype.handleFetchSuccess = function (response) {
      this.isFetching = false;
      this.renderSections(response);
      this.unbind();
      this.loading(false);
      this.complete = true;
      if (typeof this.config.callback !== "function") return;
      this.config.callback(this);
    };

    SectionRenderer.prototype.handleFetchError = function () {
      this.isFetching = false;
      this.loading(false);
    };

    SectionRenderer.prototype.getFetchURL = function () {
      if (this.config.useCurrentPath) {
        var UrlParams = new URLSearchParams(window.location.search);
        UrlParams.set("sections", this.config.sections.join(","));
        return window.location.pathname + "?" + UrlParams.toString();
      }

      return Routes.root + "?sections=" + this.config.sections.join(",");
    };

    SectionRenderer.prototype.fetchSection = function () {
      if (this.isFetching) return;
      this.isFetching = true;
      WDN.Request.Get({
        url: this.getFetchURL(),
        onSuccess: this.handleFetchSuccess.bind(this),
        onError: this.handleFetchError.bind(this),
      });
    };

    SectionRenderer.prototype.loading = function (state) {
      var action = state ? "add" : "remove";
      this.outputs.forEach(function (output) {
        output.classList[action]("loading");
      });
    };

    SectionRenderer.prototype.handleTriggerInteraction = function (e) {
      if (this.isFetching) return;
      this.loading(true);
      this.fetchSection();
      typeof this.onInteraction === "function" ? this.onInteraction() : false;
    };

    SectionRenderer.prototype.unbind = function () {
      if (!this.binded) return;
      this.triggers.forEach(function (trigger) {
        this.config.events.forEach(function (eventName) {
          trigger.removeEventListener(eventName, this.handleTriggerInteractionBound);
        }, this);
      }, this);
      this.binded = false;
    };

    SectionRenderer.prototype.bind = function () {
      this.handleTriggerInteractionBound = this.handleTriggerInteraction.bind(this);
      this.triggers.forEach(function (trigger) {
        this.config.events.forEach(function (eventName) {
          trigger.addEventListener(eventName, this.handleTriggerInteractionBound);
        }, this);
      }, this);
      this.binded = true;
    };

    SectionRenderer.prototype.reinit = function () {
      this.unbind();
      this.storeNodes();
      this.bind();
    };

    SectionRenderer.prototype.init = function () {
      this.bind();
    };

    return SectionRenderer;
  })();
}

if (typeof WDN.CSSVariable === "undefined") {
  WDN.CSSVariable = (function () {
    // functions
    var set, get;

    // root
    var root = document.documentElement;

    set = function (variable) {
      if (typeof variable.name === "undefined" || typeof variable.value === "undefined") return;
      root.style.setProperty(variable.name, variable.value);
    };

    get = function (name) {
      if (!name) return;
      return getComputedStyle(root).getPropertyValue(name);
    };

    return {
      set,
      get,
    };
  })();
}
